import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=6ac2d0ad&"
import script from "./Square.vue?vue&type=script&lang=ts&"
export * from "./Square.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports